import React from 'react';
import PropTypes from 'prop-types';
import { Shimmer } from '@pitchero/react-ui';

const ProfileHeaderStatsLoading = ({ profileType }) => {
  if (profileType !== 'player') {
    return null;
  }

  return (
    <>
      <Shimmer
        height={188}
        className="grid-profile-header__fixtures"
        style={{ gridArea: 'fixturesSummary' }}
      />
      <Shimmer height={188} className="grid-profile-header__stats" style={{ gridArea: 'stats' }} />
    </>
  );
};

ProfileHeaderStatsLoading.propTypes = {
  profileType: PropTypes.oneOf(['player', 'coach']).isRequired,
};

export default ProfileHeaderStatsLoading;
